export default __webpack_public_path__ + "static/media/umid.ff55e614.jpg";